import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { scrollRightBy } from './tv-guide-types';
import { Colors } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { zIndex } from '../../../../play-core/styles/z-index';
import { jsx as _jsx } from "react/jsx-runtime";
export const TimeJumpButton = ({
  scrollPosition,
  scrollRef,
  left,
  top,
  isListMode = false,
  timeJumpType,
  timePosition
}) => {
  const {
    t
  } = useTranslation();
  const scrollWidth = scrollRef?.current?.clientWidth ?? 0;
  const showLeft = position => scrollPosition + left > position + (isListMode ? Math.round(scrollWidth / 2) : 0);
  const showRight = position => position > scrollPosition + (isListMode ? Math.round(scrollWidth / 2) : scrollWidth);
  const showLeftButton = showLeft(timePosition);
  const showRightButton = showRight(timePosition);
  const isTimeJumpVisible = showLeftButton || showRightButton;
  const scrollTo = position => {
    const scroll = scrollRef.current;
    if (scroll) {
      if (isListMode) {
        scroll.scrollLeft = position;
      } else {
        const scrollAmount = position - (scrollPosition + Math.round(scrollWidth / 2));
        scrollRightBy(scrollRef, scrollAmount);
      }
    }
  };
  return /*#__PURE__*/_jsx(Fragment, {
    children: isTimeJumpVisible && /*#__PURE__*/_jsx(JumpButton, {
      direction: showRightButton ? 'right' : 'left',
      styleType: timeJumpType,
      left: left,
      top: top,
      tabIndex: -1,
      onClick: () => scrollTo(timePosition),
      children: t(`tvGuide.${timeJumpType}`)
    })
  });
};
const buttonHeight = 22;
const JumpButton = styled.button.withConfig({
  displayName: "TimeJumpButton__JumpButton",
  componentId: "sc-145gsq7-0"
})(["position:absolute;color:", ";background-color:", ";right:", ";left:", ";top:", "px;height:", "px;padding:3px 4px;width:58px;z-index:", ";text-transform:none;", ";", ";", ";"], Colors.WHITE, props => props.styleType === 'live' ? Colors.RED_b10017 : Colors.BLUE_2b8eeb, props => props.direction === 'right' ? `${buttonHeight / 2}px` : 'initial', props => props.direction === 'left' ? `${props.left + buttonHeight / 2}px` : 'initial', props => props.top - buttonHeight / 2, buttonHeight, zIndex.floatingAction, Fonts.medium(14), props => props.direction === 'right' && `  
      clip-path: polygon(
      0% 0%,
      82% 0%,
      83% 1%,
      84% 2%,
      100% 48%,
      100% 50%,
      100% 52%,
      84% 98%,
      83% 99%,
      82% 100%,
      0% 100%
    );
    padding-right: 10px;`, props => props.direction === 'left' && `  
    clip-path: polygon(
      18% 2%, 
      19% 1%, 
      20% 0%, 
      100% 0%, 
      100% 100%, 
      20% 100%, 
      19% 99%, 
      18% 98%, 
      0% 52%, 
      0% 50%, 
      0% 48%
    );
    padding-left: 10px;`);